import { useState } from 'react';

// MUI imports
import Box from '@mui/material/Box';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';

const QuestionText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.125rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.375rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.5rem',
  },
}));

const AnswerText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.8125rem',
  whiteSpace: 'pre-line',
  [theme.breakpoints.up('sm')]: {
    fontSize: '0.875rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.125rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.25rem',
  },
}));

const QaAccordion = ({ QAs }: { QAs: { question: string; answer: string }[] }) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {QAs.map((qa, index) => (
        <Accordion expanded={expanded === `panel${index}`} key={index} onChange={handleChange(`panel${index}`)} sx={{ width: '100%' }}>
          <AccordionSummary aria-controls={`panel${index}-content`} expandIcon={<ExpandMoreIcon />} id={`panel${index}-header`}>
            <QuestionText>{qa.question}</QuestionText>
          </AccordionSummary>
          <AccordionDetails>
            <AnswerText>{qa.answer}</AnswerText>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default QaAccordion;
